module.exports = "<ul class=\"list1\" id=\"menu\">\n  <li class=\"list-inline-item\" *ngFor=\"let p of pageList\">\n    <a class=\"nav-link\" href=\"\" routerLink=\"{{p.KP_Redirect_URL}}\" routerLinkActive=\"menu-active\">\n      <!-- <img src=\"/assets/images/icons/{{p.KP_Image_URL}}\"> -->\n      <span>{{p.KHB_Page}}</span>\n    </a>\n  </li>\n\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/finance-menu/finance-menu.component.html
// module id = ./src/app/finance/finance-menu/finance-menu.component.html
// module chunks = main